export const _en = {
    name: {
        label: "Name"
    },
    description: {
        label: "Description"
    },
    code: {
        label: "Code"
    },
    isShowCode: {
        label: "To show",
        tooltip: "Display the skill code on associated resources on the timeline"
    },
    resourceType: {
        label: "Resource type"
    },
    refDivisionId: {
        label: "Division"
    },
    skillProlongationDuration: {
        label: "Prolongation duration"
    }
};

export const _fr = {
    name: {
        label: "Nom"
    },
    description: {
        label: "Description"
    },
    code: {
        label: "Code"
    },
    isShowCode: {
        label: "A afficher <i class='far fa-info-circle'></i>",
        tooltip: "Mettre en évidence le code compétence sur le planning des ressources associées"
    },
    resourceType: {
        label: "Type de ressource"
    },
    refDivisionId: {
        label: "Service"
    },
    skillProlongationDuration: {
        label: "Durée de proprogation d'échéance (exprimée en mois)"
    }
};